import type { Fields } from "@smartsuite/smartsuite-client";

export const DATE_ICONS = [
  "text",
  "date-select",
  "date-range",
  "first-created",
  "due-date",
  "last-updated",
];

export const DATE_FIELDS: Fields[] = [
  "datefield",
  "daterangefield",
  "duedatefield",
  "firstcreatedfield",
  "lastupdatedfield",
];
